import { render } from "./WrappedText.vue?vue&type=template&id=287bc488"
import script from "./WrappedText.vue?vue&type=script&lang=js"
export * from "./WrappedText.vue?vue&type=script&lang=js"

import "./WrappedText.vue?vue&type=style&index=0&id=287bc488&lang=scss"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__